import React from 'react';
import { without } from 'lodash';
import { Checkbox } from 'react-bootstrap';

import ContentCard from '../content_card';
import { EditedResponseFilter } from '../../../types';

interface Props {
  activeFilters: EditedResponseFilter[];
  filters: EditedResponseFilter[];
  onChange: (filters: EditedResponseFilter[]) => void;
}

export default (props: Props) => {
  const filterActive = (filter) => {
    return props.activeFilters.indexOf(filter) !== -1;
  };

  const toggleFilter = (filter) => {
    if (filterActive(filter)) {
      props.onChange(without(props.activeFilters, filter));
    } else {
      props.onChange([...props.activeFilters, filter]);
    }
  };

  return (
    <ContentCard className="d-flex flex-column gap-s">
      <div><strong>Filters</strong></div>

      <div>
        <div>Themes</div>
        <div><small>View edits and their explanations by theme</small></div>
      </div>

      <div className="d-flex flex-column gap-xs">
        {
          props.filters.map((filter) => (
            <div key={filter.value}>
              <Checkbox
                checked={filterActive(filter)}
                className="u-margin-A-n"
                onChange={() => toggleFilter(filter)}
              >
                <div className="u-margin-L-xxs">{filter.name}</div>
              </Checkbox>
            </div>
          ))
        }
      </div>
    </ContentCard>
  );
};
